import CellPrice from '@/components/GokuDataGrid/CellPrice'
import {
    createColumns,
    DataTableColumn,
} from '@/components/ui/data-table-customized'
import { generatePathDatacentral, paths } from '@/utils/path'
import { Link } from 'react-router-dom'
import { Chip } from 'vnetwork-ui'
import { CustomerRevenueCombinedResult } from '../../../services'

export const getColumns = (
    t: (key: string) => string
): DataTableColumn<CustomerRevenueCombinedResult>[] =>
    createColumns<CustomerRevenueCombinedResult>([
        {
            key: 'revenue_month',
            title: t('revenue_month'),
            width: 100,
        },
        {
            key: 'product_group_name',
            title: t('product_group'),
            width: 220,
            render: (value, row) => {
                if (!row.service_id) return value || '-'
                return (
                    <Link
                        to={generatePathDatacentral(paths.serviceDetail, {
                            id: row?.service_id,
                        })}
                        className="text-primary hover:underline"
                    >
                        {[row?.service_id, row?.product_group_name]?.join(
                            ' - '
                        )}
                    </Link>
                )
            },
        },
        {
            key: 'invoice_id',
            title: t('invoice'),
            width: 100,
            render: (value, row) => {
                if (!row.invoice_id) return '-'
                return (
                    <Link
                        to={generatePathDatacentral(paths.invoiceDetail, {
                            id: row?.invoice_id,
                        })}
                        className="text-primary hover:underline"
                    >
                        {row?.invoice_id}
                    </Link>
                )
            },
        },
        {
            key: 'is_allocated',
            title: t('allocated_status'),
            width: 130,
            render: (value) => (
                <Chip
                    label={value ? t('allocated') : t('not_allocated')}
                    color={value ? 'success' : 'error'}
                    size="small"
                />
            ),
        },
        {
            key: 'is_projected',
            title: t('revenue_type_status'),
            width: 110,
            render: (_, row) => {
                const isProjected = !row.invoice_id || row.is_projected
                return (
                    <Chip
                        label={isProjected ? t('projected') : t('actual')}
                        color={isProjected ? 'warning' : 'success'}
                        size="small"
                    />
                )
            },
        },
        {
            key: 'revenue_type',
            title: t('revenue_type'),
            width: 110,
            render: (value) => {
                if (!value) return '-'
                return (
                    <Chip
                        label={t(`payment_type.${value}`)}
                        color={
                            value === 'renewal'
                                ? 'primary'
                                : value === 'new_sale'
                                  ? 'success'
                                  : 'warning'
                        }
                        size="small"
                    />
                )
            },
        },
        {
            key: 'allocated_amount',
            title: t('revenue_amount'),
            width: 140,
            cellClassName: 'text-right',
            headerClassName: 'text-right',
            render: (value, row) => {
                const amount = value || row.revenue_amount || row.total_amount
                return <CellPrice price={amount} />
            },
        },
        {
            key: 'is_paid',
            title: t('payment_status'),
            width: 120,
            render: (value, row) => {
                if (row.is_projected || !row.invoice_id) return null
                return (
                    <Chip
                        label={value ? t('paid') : t('unpaid')}
                        color={value ? 'success' : 'error'}
                        size="small"
                    />
                )
            },
        },
        {
            key: 'payment_date',
            title: t('payment_date'),
            width: 110,
            render: (value, row) => {
                if (!row.is_paid || !value) return '-'
                const date = new Date(value)
                return date.toLocaleDateString('vi-VN')
            },
        },
    ])
